var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1964 27.2768C24.1964 27.5522 24.087 27.8163 23.8922 28.0111C23.6975 28.2058 23.4333 28.3152 23.1579 28.3152H8.61944C8.39098 28.3152 8.1729 28.5229 7.98598 28.6579L4.4656 31.4306V14.8152C4.4656 14.5398 4.575 14.2757 4.76975 14.0809C4.9645 13.8862 5.22864 13.7768 5.50406 13.7768H9.51252V11.6998H5.50406C4.67781 11.6998 3.8854 12.0281 3.30115 12.6123C2.7169 13.1966 2.38867 13.989 2.38867 14.8152V33.5075C2.39022 33.7004 2.44544 33.889 2.54816 34.0522C2.65087 34.2155 2.79701 34.3469 2.97021 34.4318C3.13707 34.5076 3.32104 34.538 3.50343 34.5198C3.68583 34.5015 3.86014 34.4353 4.00867 34.3279L9.35675 30.3921H23.3137C23.7073 30.4038 24.099 30.3345 24.4648 30.1885C24.8305 30.0426 25.1623 29.8232 25.4398 29.5438C25.7172 29.2644 25.9344 28.931 26.0778 28.5642C26.2211 28.1975 26.2877 27.8052 26.2733 27.4118V26.2383H24.1964V27.2768Z",
    fill: "url(#paint0_linear_2592_10382)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5041 4.43005H14.8502C14.024 4.43005 13.2316 4.75828 12.6473 5.34253C12.0631 5.92678 11.7349 6.71919 11.7349 7.54544V20.007C11.7349 20.8332 12.0631 21.6256 12.6473 22.2099C13.2316 22.7941 14.024 23.1224 14.8502 23.1224H28.9214L33.8853 26.975C34.0328 27.0842 34.2067 27.1522 34.3891 27.1723C34.5715 27.1923 34.756 27.1637 34.9237 27.0893C35.1004 27.0051 35.2498 26.8727 35.3545 26.7074C35.4592 26.542 35.5151 26.3504 35.5156 26.1547V7.54544C35.5161 6.73687 35.2022 5.9598 34.6402 5.37845C34.0782 4.79709 33.3122 4.45701 32.5041 4.43005ZM33.5426 24.0985L29.9079 21.2635C29.7267 21.1228 29.5039 21.0462 29.2745 21.0454H14.8502C14.5748 21.0454 14.3107 20.936 14.1159 20.7413C13.9212 20.5465 13.8118 20.2824 13.8118 20.007V7.54544C13.8118 7.27002 13.9212 7.00588 14.1159 6.81114C14.3107 6.61639 14.5748 6.50698 14.8502 6.50698H32.5041C32.7817 6.53217 33.0405 6.65799 33.2318 6.86073C33.423 7.06348 33.5336 7.32916 33.5426 7.60775V24.0985Z",
    fill: "url(#paint1_linear_2592_10382)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2592_10382",
    x1: -11.7167,
    y1: 13.8072,
    x2: 108.2,
    y2: 102.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2592_10382",
    x1: -2.30808,
    y1: 6.53033,
    x2: 117.169,
    y2: 94.9356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.180be3e86d179383e408dedd1b96e892.svg";
export { ForwardRef as ReactComponent };